const WooCart = {
  init() {
    WooCart.events();
  },

  events() {
    let timeout;

    $('.cart-item__count-action.add').on('click', function () {
      // Get the input field
      var inputField = $(this).closest('.cart-item__count-main').find('.qty');

      // Get the current value and increment
      var currentValue = parseInt(inputField.val());
      inputField.val(currentValue + 1);

      WooCart.updateQuantity(inputField);
    });

    // Minus button click
    $('.cart-item__count-action.minus').on('click', function () {
      // Get the input field
      var inputField = $(this).closest('.cart-item__count-main').find('.qty');

      // Get the current value and decrement, but ensure it doesn't go below 0
      var currentValue = parseInt(inputField.val());
      inputField.val(Math.max(currentValue - 1, 1));
      WooCart.updateQuantity(inputField);
    });

    // Quantity change event
    $("body").on("change click", "input.qty", function () {
      let input = $(this);

      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        WooCart.updateQuantity(input);
      }, 500);
    });
  },
  updateQuantity: (input) => {
    let regex = /cart\[(.*?)\]\[qty\]/;
    let found = input.attr("name").match(regex);
    if (!found[1]) {
      return;
    }
    let item_key = found[1];
    let qty = input.val();

    $(".cart").addClass("cart--disabled");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "update_cart_item_quantity",
        item_key: item_key,
        qty: qty,
      },
    })
      .done((response) => {
        console.log(response);
        if (response.items) {
          let items = Object.keys(response.items);
          items.forEach((key) => {
            let data = response.items[key];
            const item = $(`.cart-item .cart-item__total-value[data-id="${key}"]`);
            item.html(data.price);
          });
        }

        if (response.vat_rates) {
          let vatRates = Object.keys(response.vat_rates);
          vatRates.forEach((key) => {
            $(`.cart-totals__item[data-id="${key}"] span`).html(
              response.vat_rates[key]
            );
          });
        }
        $(".cart-totals .cart-totals__item-value.vat").html(response.cart_vat);
        $(".cart-totals .cart-totals__item-value.total").html(response.total);
        $(".cart-totals .cart-totals__item-value-sum").html(
          response.total_vat
        );
        $('.header-button__number').html(response.count);
      })
      .always(() => {
        $(".cart").removeClass("cart--disabled");
      });
  },
};

export default WooCart;
